export default "__VITE_ASSET__C24qDaAb__"